import Preloader from 'components/Preloader';
import React from 'react';
import { ProjectionChart } from 'ui-library';
import { useGoalAndPerformance } from 'widgets/GoalAndPortfolioSetup/hooks/useGoalAndPortfolio';

const ProjectionChartComp = ({
    continueDisabled,
    t,
}) => {
    const {
        projectionOptions,
        currency,
        chartData,
        returnRates,
        isLoading: chartDataInProgress,
    } = useGoalAndPerformance({
        continueDisabledFromProps: continueDisabled,
    });

    return (
        <div>
            <Preloader isLoading={chartDataInProgress}>
                <ProjectionChart
                    data={chartData}
                    {...projectionOptions}
                    yTitle={currency}
                    yearsText={t('charts.years')}
                    returnRates={returnRates}
                    showLegend
                />
            </Preloader>

        </div>
    );
};

export default React.memo(ProjectionChartComp);
